import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../../Atoms/Typography'
import Checkbox from '../../../Atoms/Checkbox'

import theme from '../../../../styles/theme'

const Container = styled(View)`
  padding: ${1.5 * theme.gutterUnit}px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const Box = styled(View)`
  ${props => props.width ? `width: ${props.width}` : ''};
`

const Columns = styled(View)`
  flex-direction: column;
  justify-content: space-between;
`

const CheckBoxContainer = styled(View)`
  flex-direction: row;
  padding-bottom: 5px;
`

export default class GenericRadioSelection extends PureComponent {
  render () {
    const { checkboxes, boxWidth } = this.props
    return (
      <Container>
        <Box width={boxWidth}>
          <Columns>
            {checkboxes.map((c, i) => (
              <CheckBoxContainer key={i}>
                <Checkbox
                  onClick={c.handleClick}
                  isChecked={c.checked}
                  text=''
                />
                <Text fontSize={17} overrides={{ marginLeft: 20 }}>{c.label}</Text>
              </CheckBoxContainer>
            ))}
          </Columns>
        </Box>
      </Container>
    )
  }
}
